import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components/macro'

export const CatalogBackToTop = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  position: fixed;
  z-index: 10001;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2.5rem;
  border-radius: 0.8rem;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.colors.mono.greyLight};

  &.visible {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }

  &.hidden {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-50%) translateY(20px);
  }
`

export const CatalogBackToTopWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
`

export const CatalogBackToTopText = styled.span`
  color: ${({ theme }) => theme.colors.primary.default};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: bold;
  text-align: center;
`

export const CatalogBackToTopIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  width: 3rem;
  height: 3rem;
`